<template>
  <div class="loading-wrp">
    <img src="@assets/img/open.gif" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
  .loading-wrp {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 999999;
    img {
      /* width: 100%;
      height: 100%; */
      margin: 0;
      height: 0;
      width: 100%;
      height: auto;
    }
  }
  /* .loading-wrp {
    width: 100vw;
    height: 100vh;
    background: url('../../assets/img/open.gif');
    background-position: center 20%;
    background-size: cover;
  } */
</style>
